const TEMPLATE_TYPES = [
    // Add new template type here. Take example from above

    // You have to had template also on this file : WidgetBox.vue
    // In WidgetBox.vue,

    {
        id: 0,
        i: 0,
        name: 'Notifications',
        icon: 'mdi-bell-ring-outline',
        color: '#ff0000',
        type: 'small',
        w: 4,
        h: 3,
        minH: 3,
        minW: 3,
        description: 'siteDashboard.description.notifications',
    },
    // {
    //     i: 1,
    //     name: 'Inventory',
    //     icon: 'mdi-cup',
    //     color: '#ff0000',
    //     type: 'medium',
    //     w: 2,
    //     h: 5,
    //     description: 'siteDashboard.description.inventory',
    // },
    {
        id: 2,
        i: 2,
        name: 'Graphics',
        icon: 'mdi-chart-line',
        color: '#ff0000',
        type: 'medium',
        w: 4,
        h: 3,
        minH: 2,
        minW: 5,
        description: 'siteDashboard.description.graphics',
    },
    {
        id: 3,
        i: 3,
        name: 'LatestWorkOrder',
        icon: 'mdi-text-box-outline',
        color: '#ff0000',
        type: 'medium',
        w: 4,
        h: 3,
        minH: 3,
        minW: 3,
        description: 'siteDashboard.description.latestWorkOrder',

    },
    {
        id: 4,
        i: 4,
        name: 'LatestReports',
        icon: 'mdi-file-document',
        type: 'medium',
        color: '#ff0000',
        w: 4,
        h: 3,
        minH: 3,
        minW: 3,
        description: 'siteDashboard.description.latestReports',
    },
    {
        id: 5,
        i: 5,
        name: 'LatestLabReports',
        icon: 'mdi-file-document',
        type: 'medium',
        color: '#ff0000',
        w: 4,
        h: 3,
        minH: 2,
        minW: 3,
        description: 'siteDashboard.description.latestLabReports',
    },
    // Hide till calendar is implemented
    // {
    //     id: 6,
    //     i: 6,
    //     name: 'Calendar',
    //     icon: 'mdi-calendar-outline',
    //     type: 'medium',
    //     color: '#ff0000',
    //     w: 3,
    //     h: 2,
    //     minH: 2,
    //     minW: 2,
    //     description: 'siteDashboard.description.calendar',
    // },
    {
        id: 7,
        i: 7,
        name: 'UnbilledWorkOrder',
        icon: 'mdi-sack-outline',
        color: '#ff0000',
        type: 'medium',
        w: 4,
        h: 3,
        minH: 3,
        minW: 4,
        description: 'siteDashboard.description.unbilledWorkOrder',
    },
    {
        id: 8,
        i: 8,
        name: 'ServiceCalls',
        icon: 'mdi-chart-timeline-variant ',
        color: '#ff0000',
        type: 'medium',
        w: 4,
        h: 3,
        minH: 3,
        minW: 3,
        description: 'siteDashboard.description.serviceCall',
    },
    {
        id: 9,
        i: 9,
        name: 'E4',
        icon: 'mdi-view-dashboard',
        color: '#ff0000',
        type: 'medium',
        w: 4,
        h: 3,
        minH: 5,
        minW: 3,
        description: 'siteDashboard.description.e4',
    },
    {
        id: 10,
        i: 10,
        name: 'AnalysisOverview',
        icon: 'mdi-dots-grid',
        color: '#ff0000',
        type: 'medium',
        w: 8,
        h: 4,
        minH: 4,
        minW: 8,
        description: 'siteDashboard.description.analysisOverview',
    },
];


module.exports = {
    TEMPLATE_TYPES,
};
